import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$FETCH_PAYMENT_GATEWAY_CONFIG/REQUESTED';
const BLOCKED = '$FETCH_PAYMENT_GATEWAY_CONFIG/BLOCKED';
const APPROVED = '$FETCH_PAYMENT_GATEWAY_CONFIG/APPROVED';
const SUCCEEDED = '$FETCH_PAYMENT_GATEWAY_CONFIG/SUCCEEDED';
const FAILED = '$FETCH_PAYMENT_GATEWAY_CONFIG/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      locationId?: string;
      bufferMode?: boolean;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
